;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"

// Was MUI Button + styled; now plain Tailwind (keeps this off MUI/Emotion).
export default function ClearFilterButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={() => onClick()}
      className="relative flex h-[55px] w-[70px] cursor-pointer flex-col items-center justify-center rounded-[5px] border border-solid border-[#C4C4C4] bg-white px-[5px] py-3 text-center font-roboto text-[16px] font-medium leading-[19px] tracking-[0.03em] text-[#092C3C] transition-colors hover:bg-[#E0E0E0] active:cursor-grabbing min-[900px]:text-[18px]"
    >
      <div className="flex flex-col">
        <div>Clear</div>
        <div>filter</div>
      </div>
    </button>
  )
}
